import axios from "axios";
import { gitlabUrl } from "@/env";
import Entry from "@/interfaces/uniabc/Entry";
import { RepoTree } from "@/interfaces/gitlab/GitLabInterfaces";
import GitLabInfo from "@/interfaces/gitlab/GitLabInfo";
import IssueUtils from "@/utils/IssueUtils";

console.info(gitlabUrl);

axios.defaults.baseURL = `${gitlabUrl}/api/v4/`;
// headers: { "PRIVATE-TOKEN": readAccessToken(store) }

export const api = {
  async getAbcJson(projectId: number, branch: string) {
    return await axios.get<Entry[]>(
      `/projects/${projectId}/repository/files/uniabc.json/raw?ref=${branch}`
    );
  },

  async getAbcJsonMeta(projectId: number, branch: string) {
    return await axios.get(
      `/projects/${projectId}/repository/files/uniabc.json?ref=${branch}`
    );
  },

  async getCurrentUser() {
    return await axios.get("/user");
  },

  async getProjectsOfUser() {
    return await axios
      .get("/projects?membership=yes&order_by=last_activity_at&per_page=100")
      .then(r => r.data);
  },

  async getBranchesOfProject(pid: number) {
    return await axios
      .get(`/projects/${pid}/repository/branches`)
      .then(r => r.data);
  },

  async getImageUrls(pid: number, branch: string) {
    return await axios
      .get<RepoTree[]>(
        `/projects/${pid}/repository/tree?path=media/&ref=${branch}`
      )
      .then(r => r.data);
  },

  async getProject(pid: number) {
    return await axios.get(`/projects/${pid}`).then(r => r.data);
  },

  async getRawFile(pid: number, branch: string, path: string) {
    return await axios
      .get(
        `/projects/${pid}/repository/files/${encodeURIComponent(
          path
        )}/raw?ref=${branch}`
      )
      .then(r => r.data);
  },

  async getImageBase64(pid: number, branch: string, path: string) {
    return await axios
      .get(
        `/projects/${pid}/repository/files/${encodeURIComponent(
          path
        )}/raw?ref=${branch}`,
        { responseType: "arraybuffer" }
      )
      .then(r => {
        return (
          "data:;base64," +
          btoa(
            new Uint8Array(r.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          )
        );
      });
  },

  async postCommitUniAbc(
    gitLabInfo: GitLabInfo,
    uniAbcJsonStr: string,
    commitMsg: string,
    flcid: string
  ) {
    return await axios.put(
      `/projects/${gitLabInfo.projectId}/repository/files/uniabc.json`,
      {
        branch: gitLabInfo.branch,
        // eslint-disable-next-line @typescript-eslint/camelcase
        author_email: gitLabInfo.authorEmail,
        // eslint-disable-next-line @typescript-eslint/camelcase
        author_name: gitLabInfo.authorName,
        content: uniAbcJsonStr,
        // eslint-disable-next-line @typescript-eslint/camelcase
        commit_message: commitMsg,
        // eslint-disable-next-line @typescript-eslint/camelcase
        last_commit_id: flcid
      }
    );
  },

  async postCreateNewBranch(
    projId: number,
    newBranch: string,
    lastCommit: string
  ) {
    return await axios.post(`/projects/${projId}/repository/branches`, {
      branch: newBranch,
      ref: lastCommit
    });
  },

  async getWorkingOnIssues(pid: number, label: string) {
    return await axios
      .get(
        `/projects/${pid}/issues?state=opened&scope=all&labels=autogen%3A+workingonissue,&per_page=100&search=${IssueUtils.getIssueString(
          label
        )}`
      )
      .then(r => r.data);
  },

  async createNewWorkingOnIssue(
    pid: number,
    label: string,
    addTitle: string,
    description: string
  ) {
    return await axios
      .post(`/projects/${pid}/issues`, {
        labels: `autogen: workingonissue`,
        title: `Entry: ${label}; Working on Issue; ${addTitle}`,
        description: `---\n*THIS ISSUE HAS BEEN GENERATED AUTOMATICALLY. DO NOT CHANGE THE FIRST PARTS OF ITS TITLE!*\n---\n${description}`
      })
      .then(r => r.data);
  }
};
